// extracted by mini-css-extract-plugin
module.exports = {"buttonToggleGroup":"BorrowerTypeToggleGroup_buttonToggleGroup__2HpPF","buttonFromToggleGroup":"BorrowerTypeToggleGroup_buttonFromToggleGroup__3m792"};